// Define patient type
export interface Patient {
  id: string;
  name: string;
  treatmentType: string;
  adherenceRate: number;
  missedDoses: number;
  confirmedDoses: number;
  pendingDoses: number;
  startDate: string;
  nextAppointment: string;
  municipality: string;
  province: string;
  age: number;
  sex: string;
  civilStatus: string;
  philHealthNumber: string;
  phoneNumber: string;
}

// Mock patient data
export const patientData: Patient[] = [
  { 
    id: '1', 
    name: 'Juan Dela Cruz', 
    treatmentType: 'A',
    adherenceRate: 95,
    missedDoses: 1,
    confirmedDoses: 19,
    pendingDoses: 0,
    startDate: '2023-01-15',
    nextAppointment: '2023-06-15',
    municipality: 'Quezon City',
    province: 'Metro Manila',
    age: 45,
    sex: 'M',
    civilStatus: 'married',
    philHealthNumber: '01-234567890-1',
    phoneNumber: '09123456789'
  },
  { 
    id: '2', 
    name: 'Alice Guo', 
    treatmentType: 'B',
    adherenceRate: 88,
    missedDoses: 2,
    confirmedDoses: 18,
    pendingDoses: 0,
    startDate: '2023-02-01',
    nextAppointment: '2023-07-01',
    municipality: 'Quezon City',
    province: 'Metro Manila',
    age: 35,
    sex: 'F',
    civilStatus: 'single',
    philHealthNumber: '03-456789012-3',
    phoneNumber: '09345678901'
  },
  { 
    id: '3', 
    name: 'Maria Santos', 
    treatmentType: 'C',
    adherenceRate: 92,
    missedDoses: 1,
    confirmedDoses: 19,
    pendingDoses: 0,
    startDate: '2023-02-10',
    nextAppointment: '2023-07-10',
    municipality: 'Quezon City',
    province: 'Metro Manila',
    age: 38,
    sex: 'F',
    civilStatus: 'married',
    philHealthNumber: '04-567890123-4',
    phoneNumber: '09456789012'
  },
  { 
    id: '4', 
    name: 'Pedro Reyes', 
    treatmentType: 'A',
    adherenceRate: 85,
    missedDoses: 3,
    confirmedDoses: 17,
    pendingDoses: 0,
    startDate: '2023-02-15',
    nextAppointment: '2023-07-15',
    municipality: 'Quezon City',
    province: 'Metro Manila',
    age: 52,
    sex: 'M',
    civilStatus: 'married',
    philHealthNumber: '05-678901234-5',
    phoneNumber: '09567890123'
  },
  { 
    id: '5', 
    name: 'Sofia Lim', 
    treatmentType: 'B',
    adherenceRate: 90,
    missedDoses: 2,
    confirmedDoses: 18,
    pendingDoses: 0,
    startDate: '2023-02-20',
    nextAppointment: '2023-07-20',
    municipality: 'Taguig City',
    province: 'Metro Manila',
    age: 29,
    sex: 'F',
    civilStatus: 'single',
    philHealthNumber: '06-789012345-6',
    phoneNumber: '09678901234'
  },
  { 
    id: '6', 
    name: 'Antonio Garcia', 
    treatmentType: 'C',
    adherenceRate: 78,
    missedDoses: 4,
    confirmedDoses: 16,
    pendingDoses: 0,
    startDate: '2023-02-25',
    nextAppointment: '2023-07-25',
    municipality: 'Caloocan City',
    province: 'Metro Manila',
    age: 61,
    sex: 'M',
    civilStatus: 'widowed',
    philHealthNumber: '07-890123456-7',
    phoneNumber: '09789012345'
  },
  { 
    id: '7', 
    name: 'Elena Rodriguez', 
    treatmentType: 'A',
    adherenceRate: 93,
    missedDoses: 1,
    confirmedDoses: 19,
    pendingDoses: 0,
    startDate: '2023-03-01',
    nextAppointment: '2023-08-01',
    municipality: 'Caloocan City',
    province: 'Metro Manila',
    age: 42,
    sex: 'F',
    civilStatus: 'married',
    philHealthNumber: '08-901234567-8',
    phoneNumber: '09890123456'
  },
  { 
    id: '8', 
    name: 'Ricardo Tan', 
    treatmentType: 'B',
    adherenceRate: 87,
    missedDoses: 2,
    confirmedDoses: 18,
    pendingDoses: 0,
    startDate: '2023-03-05',
    nextAppointment: '2023-08-05',
    municipality: 'Caloocan City',
    province: 'Metro Manila',
    age: 55,
    sex: 'M',
    civilStatus: 'married',
    philHealthNumber: '09-012345678-9',
    phoneNumber: '09901234567'
  },
  { 
    id: '9', 
    name: 'Isabella Cruz', 
    treatmentType: 'C',
    adherenceRate: 81,
    missedDoses: 3,
    confirmedDoses: 17,
    pendingDoses: 0,
    startDate: '2023-03-10',
    nextAppointment: '2023-08-10',
    municipality: 'Las Piñas City',
    province: 'Metro Manila',
    age: 33,
    sex: 'F',
    civilStatus: 'single',
    philHealthNumber: '10-123456789-0',
    phoneNumber: '09012345678'
  },
  { 
    id: '10', 
    name: 'Gabriel Mendoza', 
    treatmentType: 'A',
    adherenceRate: 89,
    missedDoses: 2,
    confirmedDoses: 18,
    pendingDoses: 0,
    startDate: '2023-03-15',
    nextAppointment: '2023-08-15',
    municipality: 'Marikina City',
    province: 'Metro Manila',
    age: 47,
    sex: 'M',
    civilStatus: 'married',
    philHealthNumber: '11-234567890-1',
    phoneNumber: '09123456780'
  },
  { 
    id: '11', 
    name: 'Camila Villanueva', 
    treatmentType: 'B',
    adherenceRate: 94,
    missedDoses: 1,
    confirmedDoses: 19,
    pendingDoses: 0,
    startDate: '2023-03-20',
    nextAppointment: '2023-08-20',
    municipality: 'Pasay City',
    province: 'Metro Manila',
    age: 31,
    sex: 'F',
    civilStatus: 'married',
    philHealthNumber: '12-345678901-2',
    phoneNumber: '09234567891'
  },
  { 
    id: '12', 
    name: 'Mateo Ramos', 
    treatmentType: 'C',
    adherenceRate: 82,
    missedDoses: 3,
    confirmedDoses: 17,
    pendingDoses: 0,
    startDate: '2023-03-25',
    nextAppointment: '2023-08-25',
    municipality: 'Malabon City',
    province: 'Metro Manila',
    age: 58,
    sex: 'M',
    civilStatus: 'widowed',
    philHealthNumber: '13-456789012-3',
    phoneNumber: '09345678902'
  },
  { 
    id: '13', 
    name: 'Valentina Aquino', 
    treatmentType: 'A',
    adherenceRate: 91,
    missedDoses: 1,
    confirmedDoses: 19,
    pendingDoses: 0,
    startDate: '2023-04-01',
    nextAppointment: '2023-09-01',
    municipality: 'Navotas City',
    province: 'Metro Manila',
    age: 27,
    sex: 'F',
    civilStatus: 'single',
    philHealthNumber: '14-567890123-4',
    phoneNumber: '09456789013'
  },
  { 
    id: '14', 
    name: 'Santiago Reyes', 
    treatmentType: 'B',
    adherenceRate: 86,
    missedDoses: 2,
    confirmedDoses: 18,
    pendingDoses: 0,
    startDate: '2023-04-05',
    nextAppointment: '2023-09-05',
    municipality: 'Valenzuela City',
    province: 'Metro Manila',
    age: 49,
    sex: 'M',
    civilStatus: 'married',
    philHealthNumber: '15-678901234-5',
    phoneNumber: '09567890124'
  },
  { 
    id: '15', 
    name: 'Cristina Mercado', 
    treatmentType: 'C',
    adherenceRate: 91,
    missedDoses: 2,
    confirmedDoses: 18,
    pendingDoses: 0,
    startDate: '2023-03-10',
    nextAppointment: '2023-08-10',
    municipality: 'Mandaluyong City',
    province: 'Metro Manila',
    age: 36,
    sex: 'F',
    civilStatus: 'married',
    philHealthNumber: '16-789012345-6',
    phoneNumber: '09678901235'
  },
  { 
    id: '16', 
    name: 'Cardo Dalisay', 
    treatmentType: 'A',
    adherenceRate: 94,
    missedDoses: 1,
    confirmedDoses: 19,
    pendingDoses: 0,
    startDate: '2023-03-15',
    nextAppointment: '2023-08-15',
    municipality: 'Cebu City',
    province: 'Cebu',
    age: 40,
    sex: 'M',
    civilStatus: 'married',
    philHealthNumber: '17-890123456-7',
    phoneNumber: '09789012346'
  },
  { 
    id: '17', 
    name: 'Elena Magbanua', 
    treatmentType: 'B',
    adherenceRate: 83,
    missedDoses: 3,
    confirmedDoses: 17,
    pendingDoses: 0,
    startDate: '2023-03-18',
    nextAppointment: '2023-08-18',
    municipality: 'Davao City',
    province: 'Davao del Sur',
    age: 32,
    sex: 'F',
    civilStatus: 'single',
    philHealthNumber: '18-901234567-8',
    phoneNumber: '09890123457'
  },
  { 
    id: '18', 
    name: 'Ramon Magtanggol', 
    treatmentType: 'C',
    adherenceRate: 76,
    missedDoses: 5,
    confirmedDoses: 15,
    pendingDoses: 0,
    startDate: '2023-03-20',
    nextAppointment: '2023-08-20',
    municipality: 'Davao City',
    province: 'Davao del Sur',
    age: 53,
    sex: 'M',
    civilStatus: 'married',
    philHealthNumber: '19-012345678-9',
    phoneNumber: '09901234568'
  },
  { 
    id: '19', 
    name: 'Margarita Salazar', 
    treatmentType: 'A',
    adherenceRate: 89,
    missedDoses: 2,
    confirmedDoses: 18,
    pendingDoses: 0,
    startDate: '2023-03-22',
    nextAppointment: '2023-08-22',
    municipality: 'Iloilo City',
    province: 'Iloilo',
    age: 39,
    sex: 'F',
    civilStatus: 'married',
    philHealthNumber: '20-123456789-0',
    phoneNumber: '09012345679'
  },
  { 
    id: '20', 
    name: 'Benjamin Lacson', 
    treatmentType: 'B',
    adherenceRate: 92,
    missedDoses: 1,
    confirmedDoses: 19,
    pendingDoses: 0,
    startDate: '2023-03-25',
    nextAppointment: '2023-08-25',
    municipality: 'Bacolod City',
    province: 'Negros Occidental',
    age: 45,
    sex: 'M',
    civilStatus: 'married',
    philHealthNumber: '21-234567890-1',
    phoneNumber: '09123456781'
  }
];

// Mock medication data
export const medicationData = [
  { id: '1', name: 'Pyrazinamide', dosage: '500mg', frequency: 'Daily', patients: 15 },
  { id: '2', name: 'Ethambutol', dosage: '400mg', frequency: 'Daily', patients: 12 },
  { id: '3', name: 'Rifampicin', dosage: '600mg', frequency: 'Daily', patients: 18 },
  { id: '4', name: 'Isoniazid', dosage: '300mg', frequency: 'Daily', patients: 10 },
  { id: '5', name: 'Rifabutin', dosage: '150mg', frequency: 'Daily', patients: 5 },
];

// Mock adverse reaction data
export const adverseReactionData = [
  {
    patientId: '1',
    patientName: 'Juan Dela Cruz',
    date: '2024-02-10',
    reaction: 'Jaundice due to hepatitis',
    drugs: 'Isoniazid, Rifampicin',
    management: 'Stopped anti-TB drugs, referred to specialist',
    status: 'Resolved',
    isEmergency: true
  },
  {
    patientId: '3',
    patientName: 'Maria Santos',
    date: '2024-01-25',
    reaction: 'Visual impairment due to optic neuritis',
    drugs: 'Ethambutol',
    management: 'Stopped Ethambutol, referred to ophthalmologist',
    status: 'Ongoing monitoring',
    isEmergency: false
  },
  {
    patientId: '16',
    patientName: 'Cardo Dalisay',
    date: '2024-02-15',
    reaction: 'Skin rash',
    drugs: 'Pyrazinamide',
    management: 'Antihistamines prescribed',
    status: 'Resolved',
    isEmergency: false
  },
  {
    patientId: '17',
    patientName: 'Elena Magbanua',
    date: '2024-02-20',
    reaction: 'Nausea and vomiting',
    drugs: 'Rifampicin',
    management: 'Medication timing adjusted',
    status: 'Improved',
    isEmergency: false
  },
  {
    patientId: '5',
    patientName: 'Sofia Lim',
    date: '2024-03-01',
    reaction: 'Joint pain',
    drugs: 'Pyrazinamide',
    management: 'Pain relievers prescribed',
    status: 'Ongoing',
    isEmergency: false
  }
]; 